import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import cubaimg from "../../assets/images/logo/fitFind2.png"
import CustomizerContext from '../../_helper/Customizer';

const SidebarIcon = () => {
  const { layoutURL } = useContext(CustomizerContext);
  return (
    <div className="logo-icon-wrapper" style={{ padding: window.innerWidth >= 1024 ? "0px" : "" , backgroundColor:"rgb(47 172 176)" }}>
      <Link to={`${process.env.PUBLIC_URL}/pages/dashborad/`}>
        <img
          className="img-fluid"
          src={cubaimg}
          style={{ height: "60px", width: "90px" }}
          alt=""
        />
      </Link>
    </div>
  );
};

export default SidebarIcon;